import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const znanyLekarzService = {
    GetFacilities,
    GetDoctors
};

function GetFacilities()
{
    return axios.get('/api/services/app/ZnanyLekarzService/GetFacilities', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function GetDoctors()
{
    return axios.get('/api/services/app/ZnanyLekarzService/GetDoctors', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}

